import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = "https://ggaarts.onrender.com/api";

/* ===========================
   SKELETON CARD COMPONENT
=========================== */
const ShopSkeleton = () => (
  <div className="shop-card skeleton-card">
    <div className="shop-img-box skeleton-img shimmer"></div>
    <div className="skeleton-text shimmer"></div>
  </div>
);

const Shop = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/artworks`);
      setItems(res.data);
    } catch (err) {
      console.error("Shop Error:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="shop-container">
      <h1 className="shop-title">All Artworks</h1>

      <div className="shop-grid">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => (
              <ShopSkeleton key={i} />
            ))
          : items.map((art) => (
              <div className="shop-card" key={art._id}>
                <Link
                  to={`/artwork/${art._id}`}
                  className="shop-link-wrapper"
                >
                  {art.category === "content_creators" ? (
                    <div className="not-sale-tag-shop">
                      Not for Sale
                    </div>
                  ) : (
                    <div className="price-tag-shop">
                      ₹{art.price}
                    </div>
                  )}

                  <div className="shop-img-box">
                    <img
                      className="shop-img"
                      src={art.image}
                      alt={art.name}
                      loading="lazy"
                      onError={(e) =>
                        (e.target.src =
                          "https://via.placeholder.com/300x200?text=No+Image")
                      }
                    />
                    {art.sold && (
                      <div className="sold-badge">SOLD</div>
                    )}
                  </div>

                  <h3 className="shop-name">{art.name}</h3>
                </Link>

                {art.category !== "content_creators" && (
                  <button className="shop-card-btn">
                    Add to Cart
                  </button>
                )}
              </div>
            ))}
      </div>
    </div>
  );
};

export default Shop;